import { AppStatusConfig } from '../models/application-status-config.interface';

export class AppealStatus {
	static APPEAL_STATUSES: { [statusId: number]: AppStatusConfig } = {
		0: {
			id: 0,
			title: 'Default',
			color: 'gray',
			adminColor: 'gray',
			icon: 'icon-statusComplete'
		},
		2: {
			id: 2,
			title: 'Appeal Submitted - Pending Review',
			color: 'yellow',
			adminColor: 'yellow',
			icon: 'icon-statusComplete'
		},
		3: {
			id: 3,
			title: 'Appeal Incomplete',
			color: 'yellow',
			adminColor: 'yellow',
			icon: 'icon-statusComplete'
		},
		4: {
			id: 4,
			title: 'Appeal Approved',
			color: 'green',
			adminColor: 'green',
			icon: 'icon-statusComplete'
		},
		5: {
			id: 5,
			title: 'Appeal Denied',
			color: 'red',
			adminColor: 'red',
			icon: 'icon-statusComplete'
		},
		6: {
			id: 6,
			title: 'Appeal Forwarded to Designee',
			color: 'yellow',
			adminColor: 'yellow',
			icon: 'icon-statusComplete'
		},
		7: {
			id: 7,
			title: 'Appeal Cancelled',
			color: 'red',
			adminColor: 'red',
			icon: 'icon-statusComplete'
		}
	};
}
